import {
    PRIVILEGE_CREATE,
    PRIVILEGE_FETCH,
    PRIVILEGE_FETCH_DESC,
    PRIVILEGE_UPDATE
} from '../actions/types';

const INITIAL_STATE = { 
    loading: false,
    privileges: null,
    desc: ""
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
        case PRIVILEGE_CREATE:
            return { ...state, loading: action.payload }
        case PRIVILEGE_FETCH:
            return { ...state, privileges: action.payload }
        case PRIVILEGE_FETCH_DESC:
            return { ...state, desc: action.payload }
        case PRIVILEGE_UPDATE:
            return { ...state, loading: action.payload }
        default:
            return state
    }
}